module.exports = __webpack_public_path__ + "static/img/midtrans.e20c5e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/partners/midtrans.png
// module id = fCNL
// module chunks = 1